// This icon file is generated automatically.
var TimeOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10 20a10 10 0 110-20 10 10 0 010 20zm0-1.4a8.6 8.6 0 100-17.2 8.6 8.6 0 000 17.2zm-.23-7.44h4.88a.7.7 0 010 1.4H9.07a.7.7 0 01-.7-.7V6.28a.7.7 0 011.4 0v4.88z" } }] }, "name": "time", "theme": "outlined" };
export default TimeOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/TimeOutlined.js
// module id = 4260
// module chunks = 0